import { AlertTriangle } from "lucide-react";

import { useSystemHealth } from "@/hooks/useSystemHealth";

/**
 * Banner que avisa el modo de operación del SOAR. El modo lo reporta el
 * backend en `/api/v1/health/system` (campo `dry_run`, derivado de la métrica
 * `aroc_soar_dry_run` del SOAR) — ya NO está hardcoded como en Fase 6
 * (dev_log #569).
 *
 * Se auto-oculta SOLO cuando el backend reporta `dry_run === false` (live).
 * Mientras carga o si el health falla, se muestra: es el default honesto, no
 * afirmamos "todo en vivo" sin confirmarlo. Gatear acá (y no en cada página)
 * mantiene el comportamiento consistente en Dashboard, Runs, Health y detalle
 * de incidente sin repetir la condición.
 */
export function DryRunBanner() {
  const { data } = useSystemHealth();
  if (data?.dry_run === false) {
    return null;
  }
  return (
    <div
      role="status"
      className="flex items-center gap-3 rounded-md border border-amber-300 bg-amber-100 px-4 py-3 text-sm text-amber-900"
    >
      <AlertTriangle className="size-5 shrink-0" />
      <p>
        <strong>Modo dry-run.</strong> AROC no ejecuta acciones automáticas
        contra la infraestructura; solo las acciones aprobadas por un operador
        se ejecutan en vivo.
      </p>
    </div>
  );
}
